import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

import './App.css';
import LandingPage from './containers/LandingPage/LandingPage';
// import MotorDataPhasesPage from './containers/MotordataPages/MotorDataPhasesPage/MotorDataPhasesPage';
// import MotorDataHPPage from './containers/MotordataPages/MotorDataHPPage/MotorDataHPPage';
// import MotorDataVoltagePage from './containers/MotordataPages/MotorDataVoltagePage/MotorDataVoltagePage';
// import WireSelectorPage from './containers/WireDataPages/WireSelectorPage/WireSelectorPage';
// import WireInfoPage from './containers/WireDataPages/WireInfoPage/WireInfoPage';
import TransformerDataPage from './containers/TransformerDataPage/TransformerDataPage';
import MorePage from './containers/MorePage/MorePage';

class App extends Component {
  state = {
    selectedCountry: this.getCountry(),
    language: this.getLanguage()
  };

  getParameterByName(name) {
    const url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);

    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  getLanguage() {
    return this.getParameterByName('language')
      ? this.getParameterByName('language').toLowerCase()
      : 'en';
  }

  getCountry() {
    const capitalizeFirstLetter = string => {
      return string.charAt(0).toUpperCase() + string.slice(1);
    };

    const recdievedCountry = this.getParameterByName('country');
    let selectedCountry = 'USA';

    if (
      recdievedCountry === 'Canada' ||
      recdievedCountry === 'canada' ||
      recdievedCountry === 'CANADA'
    ) {
      selectedCountry = capitalizeFirstLetter(
        recdievedCountry.toLowerCase()
      );
    }

    if (
      recdievedCountry === 'usa' ||
      recdievedCountry === 'USA' ||
      recdievedCountry === 'Usa'
    ) {
      selectedCountry = recdievedCountry.toUpperCase();

    }

    return selectedCountry;
  }

  handleCanadaENSelection = () => {
    this.setState({
      selectedCountry: 'Canada',
      language: 'en'
    });
  };

  handleCanadaFRSelection = () => {
    this.setState({
      selectedCountry: 'Canada',
      language: 'fr'
    });
  };

  handleUSASelection = () => {
    this.setState({
      selectedCountry: 'USA',
      language: 'en'
    });
  };

  render() {
    const { selectedCountry, language } = this.state;
    return (
      <Switch>
        <Route
          path="/transformer-data"
          exact
          render={() => (
            <TransformerDataPage
              country={selectedCountry}
              language={language}
              selectedCanadaEN={this.handleCanadaENSelection}
              selectedCanadaFR={this.handleCanadaFRSelection}
              selectedUSA={this.handleUSASelection}
            />
          )}
        />
        <Route
          path="/more"
          render={() => (
            <MorePage
              country={selectedCountry}
              language={language}
              selectedCanadaEN={this.handleCanadaENSelection}
              selectedCanadaFR={this.handleCanadaFRSelection}
              selectedUSA={this.handleUSASelection}
            />
          )}
        />
        <Route
          path="/"
          exact
          render={() => (
            <LandingPage
              country={selectedCountry}
              language={language}
              selectedCanadaEN={this.handleCanadaENSelection}
              selectedCanadaFR={this.handleCanadaFRSelection}
              selectedUSA={this.handleUSASelection}
            />
          )}
        />
      </Switch>
    );
  }
}

export default withRouter(App);
